import axios from 'axios';
import api from '../../../utils/api';
import {
  MP_NOTIFICATION_LIST, MP_REQUESTED_BY, NEW_NOTIFICATIONS, CURRENT_NOTIFICATION,
  DECREMENT_NEW_NOTIFS_COUNT, UNREAD_NOTIFICATIONS,
  // SEARCHED_NOTIFICATIONS,
} from './types';

export default {
  async meetingPlannerInvitationList({ commit }, reqData) {
    const { data } = await axios(api.meetings.meetingPlannerInvitationList(reqData));
    commit(MP_NOTIFICATION_LIST, { mPInvitationList: data.results });
    return data;
  },
  async meetingPlannerRequestedBy({ commit }, customerId) {
    const { data } = await axios(api.meetings.meetingPlannerRequestedBy(customerId));
    commit(MP_REQUESTED_BY, { mPRequestedBy: data.results });
    return data;
  },
  async acceptOrRefuseInvitation({}, invitationResponse) {
    const data = await axios(api.meetings.acceptOrRefuseInvitation(invitationResponse));
    return data;
  },
  async fetchNotifications({ commit }, pagination) {
    const { data } = await axios(api.notifications.fetchNotifications(pagination));
    commit(NEW_NOTIFICATIONS, { ...data });
    return data;
  },
  async fetchUnreadNotifications({ commit }) {
    const { data } = await axios(api.notifications.fetchUnreadNotifications());
    commit(UNREAD_NOTIFICATIONS, { ...data });
    return data;
  },
  // async searchNotifications({ commit }, search) {
  //   const { data } = await axios(api.notifications.searchNotifications(search));
  //   commit(SEARCHED_NOTIFICATIONS, { ...data });
  //   return data;
  // },
  async fetchSingleNotification({}, id) {
    const { data } = await axios(api.notifications.fetchSingleNotification(id));
    return data;
  },
  async fetchSingleNotificationTemplate({}, id) {
    const { data } = await axios(api.notifications.fetchSingleNotificationTemplate(id));
    return data;
  },
  async editNotification({ commit }, notifData) {
    const { data } = await axios(api.notifications.editNotification(notifData));
    commit(DECREMENT_NEW_NOTIFS_COUNT);
    return data;
  },
  async archivNotification({}, notifData) {
    const { data } = await axios(api.notifications.editNotification(notifData));
    return data;
  },
  async getCurrentNotification({ commit }, url) {
    const { data } = await axios(api.notifications.getCurrentNotification(url));
    commit(CURRENT_NOTIFICATION, { notif: data });
    return data;
  },
};
